<template>
  <div>
    <top-bar voltar="admin/" fullscreen="true"/>
    <div class="w3-main w3-small" style="margin-top:50px;">
      <header class="w3-container" style="padding-top:14px">
        <h6><b>Relatórios</b></h6>
        <hr>
      </header>
      <div class="w3-margin-bottom">
        <div class="w3-row-padding" style="margin: 22px 0 45px">
          <div class="w3-col m3 w3-hide-small">&nbsp;</div>
          <div class="w3-col m2">
            <div class="w3-padding-16 w3-round w3-center w3-dark-gray" style="margin-bottom: 15px">
              <div class="w3-large">
                <b>R$ {{totais.comprados | valor}}</b>
              </div>
              <span class="w3-small"><b>Total comprado</b></span>
            </div>
          </div>
          <div class="w3-col m2">
            <div class="w3-padding-16 w3-round w3-center w3-dark-gray" style="margin-bottom: 15px">
              <div class="w3-large">
                <b>R$ {{totais.pagos | valor}}</b>
              </div>
              <span class="w3-small"><b>Total pago</b></span>
            </div>
          </div>
          <div class="w3-col m2">
            <div class="w3-padding-16 w3-round w3-center w3-blue-gray" style="margin-bottom: 15px">
              <div class="w3-large">
                <b>R$ {{totais.pendentes | valor}}</b>
              </div>
              <span class="w3-small"><b>Pendentes</b></span>
            </div>
          </div>
        </div>
        <hr class="w3-padding">
        <div class="w3-row-padding">
          <div class="w3-col l6">
            <div class="w3-margin-bottom" style="font-size: 14px"><b>Vendas por Período</b></div>
            <div class="w3-row-padding w3-white w3-card w3-padding-24">
              <div class="w3-col m12">
                <label><b>Período</b></label>
                <select class="w3-select w3-white w3-border" title="Periodo" v-model="periodoVPP" @change="buscarVendasPorPeriodo">
                  <option value="1">Mês</option>
                  <option value="3">3 Meses</option>
                  <option value="6">6 Meses</option>
                  <option value="12">Ano</option>
                </select>
              </div>
              <div class="w3-col m12 w3-margin-top">
                <vendas-por-perido :dados="vendasPorPeriodo"/>
              </div>
            </div>
          </div>

          <div class="w3-col l6">
            <div class="w3-margin-bottom" style="font-size: 14px"><b>Comparativo de vendas</b></div>
            <div class="w3-row-padding w3-white w3-card w3-padding-24">
              <div class="w3-col m6">
                <label><b>Período</b></label>
                <select class="w3-select w3-white w3-border" title="Periodo" @change="buscarVendasPorPeriodo">
                  <option value="1">Mês Atual</option>
                </select>
              </div>
              <div class="w3-col m6">
                <label><b>Período</b></label>
                <select class="w3-select w3-white w3-border" title="Periodo" @change="buscarVendasPorPeriodo">
                  <option value="1">Mês Anterior</option>
                </select>
              </div>
              <div class="w3-col m12 w3-margin-top">
                <comparativo-por-periodo :dados="comparativoPorPeriodo"/>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TopBar from "../../commons/TopBar.vue"
  import VendasPorPerido from "./graficos/VendasPorPeriodo"
  import ComparativoPorPeriodo from "./graficos/ComparativoPorPeriodo"

  export default {
    components: {TopBar, VendasPorPerido, ComparativoPorPeriodo},

    data() {
      return {
        token: localStorage.getItem('key'),
        periodoVPP: 1,
        vendasPorPeriodo: [],

        comparativoPorPeriodo: {
          periodo1: [],
          periodo2: [],
        },

        totais: {
          comprados: 0,
          pagos: 0,
          pendentes: 0,
        }
      }
    },

    methods: {
      buscarVendasTotais() {
        openLoading("Buscando vendas");
        console.log(base_url + 'relatorios/totais-vendas/'  + this.token);
        this.$http.get(base_url + 'relatorios/totais-vendas/'  + this.token)
            .then(response => {
                setTimeout(() => {
                    this.totais = response.data;
                    closeLoading();
                },1500)

            }, res => {
                closeLoading();
                openModalMsg(res.data.result,res.data.msg);
            });
      },

      buscarVendasPorPeriodo() {
        openLoading("Buscando vendas");
        console.log(base_url + 'relatorios/vendas-por-periodo/'  + this.token + '/?periodo=' + this.periodoVPP);
        this.$http.get(base_url + 'relatorios/vendas-por-periodo/'  + this.token + '/?periodo=' + this.periodoVPP)
          .then(response => {
            setTimeout(() => {
              this.vendasPorPeriodo = response.data;
              closeLoading();
            },1500)

          }, res => {
            closeLoading();
            openModalMsg(res.data.result,res.data.msg);
          });
      },

      buscarComparativoPorPeriodo() {
        openLoading("Buscando vendas");
        this.$http.get(base_url + 'relatorios/comparativo-por-periodo/'  + this.token + '/?periodo1=1&periodo2=2')
          .then(response => {
            setTimeout(() => {
              this.comparativoPorPeriodo = response.data;
              closeLoading();
            },1500)

          }, res => {
            closeLoading();
            openModalMsg(res.data.result,res.data.msg);
          });
      },
    },

    mounted () {
      this.buscarVendasPorPeriodo();
      this.buscarComparativoPorPeriodo();
      this.buscarVendasTotais();
    },

    filters: {
      valor(value) {
          if (value !== null && value !== undefined) {
              return parseFloat(value).toFixed(2);
          } else  {
              return parseFloat('0').toFixed(2);
          }
      }
    }

  }
</script>

<style scoped>
  .w3-centered tr td {
    cursor: pointer;
    padding: 13px
  }

  .w3-table td {
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/relatorio/AdminRelatorios.vue